import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";
import { Text } from "../components/Text";

type Input = { step: string };

function RunStepHeader({ toolUse, result, interrupted }: ToolUseProps) {
  const input = toolUse.input as Input | undefined;
  const stepName = input?.step;
  const done = !!result && !result.isError;
  const text = stepName
    ? done
      ? `Ran ${stepName}`
      : `Running ${stepName}…`
    : "";
  return (
    <ToolStatus icon="solo-run" text={text} pending={!done && !interrupted} />
  );
}

function RunStepBody({ toolUse, result }: ToolUseProps) {
  return (
    <Text variant="code-small" color="var(--text-secondary)">
      <pre
        style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
      >
        {JSON.stringify(toolUse.input, null, 2)}
      </pre>
      {result && (
        <pre
          style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {JSON.stringify(result.output, null, 2)}
        </pre>
      )}
    </Text>
  );
}

export const runStep: ChatTool = {
  name: "runStep",
  Header: RunStepHeader,
  Body: RunStepBody,
};
